import { render, staticRenderFns } from "./bandWeChat.vue?vue&type=template&id=c7d869ba&scoped=true"
import script from "./bandWeChat.vue?vue&type=script&lang=js"
export * from "./bandWeChat.vue?vue&type=script&lang=js"
import style0 from "./bandWeChat.vue?vue&type=style&index=0&id=c7d869ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7d869ba",
  null
  
)

export default component.exports